import { UIMessage } from "@ai-sdk/react";
import { AiChatPart, TessaAiChatPart, TessaChatMessage } from "@gettactic/api";
import { UIDataTypes, UITools } from "ai";
import { getToolCallComponent } from "@/features/tessa/components/tools/ChatBotSimpleToolCall";
import { ChatBotTextTool } from "@/features/tessa/components/tools/ChatBotTextTool";
import { ChatBotToolShowReport } from "@/features/tessa/components/tools/ChatBotToolShowReport";
import { ChatBotToolShowReservationInfo } from "@/features/tessa/components/tools/ChatBotToolShowReservationInfo";
import { ChatBotToolShowUsersWorkingLocations } from "@/features/tessa/components/tools/ChatBotToolShowUsersWorkingLocations";
import { ChatBotToolShowWorkplaceRequestInfo } from "@/features/tessa/components/tools/ChatBotToolShowWorkplaceRequestInfo";

export interface TessaMessageRendererProps<
  T extends AiChatPart = TessaAiChatPart
> {
  part: T;
  isResponse?: boolean;
  message?: TessaChatMessage | TessaResponseMessages;
}

export type TessaResponseMessages = UIMessage<unknown, UIDataTypes, UITools>;

export const messageTypeToComponentMap = {
  text: ChatBotTextTool,
  "tool-show_workplace_request_info": ChatBotToolShowWorkplaceRequestInfo,
  "tool-show_users_working_locations": ChatBotToolShowUsersWorkingLocations,
  "tool-show_reservation_info": ChatBotToolShowReservationInfo,
  "tool-show_report": ChatBotToolShowReport,
  "tool-build_report_query": getToolCallComponent("Running the report"),
  "tool-get_current_date_time": getToolCallComponent("Getting current time"),
  "tool-get_date_time": getToolCallComponent("Calculating date and time"),
  "tool-find_users": getToolCallComponent("Finding users"),
  "tool-find_teams": getToolCallComponent("Finding teams"),
  "tool-search_offices_documents": getToolCallComponent("Searching documents"),
  "tool-find_available_resources": getToolCallComponent(
    "Finding available resources"
  ),
  "tool-get_users_working_locations_at_week": getToolCallComponent(
    "Getting users locations"
  ),
  "tool-get_users_in_office_at_week": getToolCallComponent(
    "Getting users in office"
  )
};
